import styled from 'styled-components'
import { colors } from '../../theme'

type TitleType = 'PRINCIPAL' | 'SUB-TITLE'

// export const Title = styled.h3<{ titleType: TitleType }>`
//   margin-bottom: ${({ titleType }) =>
//     titleType === 'PRINCIPAL' ? `50px` : '4px'};
//   font-size: ${({ titleType }) =>
//     titleType === 'PRINCIPAL' ? `36px` : '20px'};
//   font-weight: ${({ titleType }) =>
//     titleType === 'PRINCIPAL' ? `700px` : '600px'};
//   font-family: 'Sora', sans-serif;
//   color: ${({ titleType }) =>
//     titleType === 'PRINCIPAL' ? `${colors.grey900}` : `${colors.grey800}`};
// `
export const Title = styled.h3<{ titleType: TitleType }>`
  margin-bottom: ${({ titleType }) =>
    titleType === 'PRINCIPAL' ? `50px` : '4px'};
  font-size: ${({ titleType }) =>
    titleType === 'PRINCIPAL' ? `36px` : '20px'};
  font-weight: ${({ titleType }) =>
    titleType === 'PRINCIPAL' ? `700px` : '600px'};
  font-family: 'Roboto', sans-serif;
  color: ${({ titleType }) =>
    titleType === 'PRINCIPAL' ? `${colors.grey900}` : `${colors.white}`};
`
export const SubTitle = styled.h3`
  color: ${colors.white};
  font-size: 11.5px;
  font-weight: 400;
  margin: 8px 1px;
`
export const EmailEnviado = styled.h3`
  color: ${colors.white};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  margin: 14px 0px;
`
export const MsgEmailEnviado = styled.h3`
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 600px;
  font-family: 'Roboto', sans-serif;
  color: ${colors.white};
  text-align: center;
`
/* Era um CIRCULO BRANCO de 50px com o GIF de e-mail (fundo branco solido)
   dentro — no cartao escuro virava um disco branco. Passou a exibir o icone de
   confirmacao da marca, sem moldura. O padding assimetrico antigo
   (10px 52px 5px 12px) existia so para centralizar o GIF dentro do circulo. */
export const IconEmail = styled.h3`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  svg {
    width: 48px;
    height: 48px;
  }
`
